import './reset_pass_code.css';
import { useEffect, useRef, useState } from 'react';
import { BarLoader } from '../BarLoader/BarLoader';
import { LoginScreen, useLogin } from '../../pages/login/LoginContext';
import { useServer } from '../../context/ServerContext';
import { endpoints } from '../../env';

export const ResetPassCode = () => {
    //HOOKS
    const { 
        ActiveScreen,
        setActiveScreen,
        recoverEmail,
        recoverCode,
        setRecoverCode,
    } = useLogin();

    const { postRequest } = useServer();

    //REFS
    const formRef = useRef();

    //STATES
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    const validateCode = () => {
        if (loading) {
            return;
        }

        setLoading(true);
        setErrorMsg("");

        const data = {
            code: recoverCode,
        }

        postRequest(endpoints.recover_code_check, data, (res) => {
            setLoading(false);

            if (res[0]) {
                res = res[1];
                if (res.success) {
                    setActiveScreen(LoginScreen.PASSWORD_RESET);
                } else {
                    setErrorMsg("Invalid code.");
                }
            } else {
                setErrorMsg("Server error, please try again in a bit.");
            }
        });
    }

    const resendCode = () => {
        if (loading) {
            return;
        }

        setLoading(true);
        setErrorMsg("");

        const data = {
            email: recoverEmail,
        }

        postRequest(endpoints.send_recover, data, (res) => {
            setLoading(false);
            if (res[0]) {
                res = res[1];

                if (res.success) {
                    setErrorMsg("A new code was sent to your email");
                } else {
                    setErrorMsg("Server error, please try again in a bit.");
                }
            } else {
                setErrorMsg("Server error, please try again in a bit.");
            }
        });
    }

    //EFFECTS
    useEffect(() => {
        if (ActiveScreen === LoginScreen.RECOVER_CODE) {
            formRef.current.classList.add('active');
        } else {
            formRef.current.classList.remove('active');
        }
    }, [ActiveScreen]);

    return (
        <div className='reset_code_form' ref={formRef}>
            <button className='close' onClick={() => setActiveScreen(LoginScreen.MAIN_SCREEN)}>
                <i className="fa-solid fa-chevron-down"></i>
            </button>
            <h2 className="title">
                Reset your password
            </h2>
            <span className='subtitle'>Enter the code we sent you to {recoverEmail}</span>
            <div className='form'>
                <div className='input_group'>
                    <label>Code</label>
                    <input type='text' placeholder='XXXXXX' value={recoverCode} onChange={(e) => setRecoverCode(e.target.value)} />
                </div>
                <p className='forgot' onClick={resendCode}>
                    Resend email
                </p>
                {
                    errorMsg !== "" && (
                        <span className='error_msg'>
                            {errorMsg}
                        </span>
                    )
                }
                {
                    loading && (
                        <div className='loader'>
                            <BarLoader />
                        </div>
                    )
                }
                <button disabled={loading} onClick={validateCode}>
                    Reset password
                </button>
            </div>
        </div>
    );
};